module.exports = __webpack_public_path__ + "static/ma-2-4801cfaafcc2dcd7d2895dbd991b1413.png";